import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import TextField from '@material-ui/core/TextField'
import FormHelperText from '@material-ui/core/FormHelperText'
import Button from '@material-ui/core/Button'

class LoginForm extends React.Component {

    render() {
        
        return (
            <div className='loginForm'>
                <div className='container'>
                       <div className='logoContainer center'>
                       <img src={require('../../images/logoLogin.png')} alt=""/>
                        </div>
                    <div className='inputContainer'>
                        <TextField className='myInput'
                            label="Correo electrónico" 
                            value={this.props.loginData.email}
                            name="email"
                            onChange={(e) => this.props.handleOnDataChange(e)}
                            error={this.props.errores.email !== undefined}
                        />
                        {this.props.errores.email !== undefined && 
                        <FormHelperText error>{this.props.errores.email}</FormHelperText>}
                    </div>

                    <div className='inputContainer'>
                        <TextField className='myInput'
                            label="Contraseña" 
                            value={this.props.loginData.contrasenia}
                            type="password"
                            name="contrasenia"
                            onChange={(e) => this.props.handleOnDataChange(e)}
                            onKeyPress={this.props.handleOnContraseniaKeyPress}
                            error={this.props.errores.contrasenia !== undefined}
                        />
                        {this.props.errores.contrasenia !== undefined && 
                        <FormHelperText error>{this.props.errores.contrasenia}</FormHelperText>}
                    </div>

                    
                    <span className='myLabel link olvidoContrasenia' onClick={this.props.handleOnOlvidoContrasenia}>Olvidó su contraseña?</span>

                    <Button onClick={this.props.handleOnAutenticar} variant="fab" aria-label="Add" className='btnPrincipal btnLogin'>
                        INGRESAR
                    </Button>

                    {/*<Link to='/RegistrarUsuario'>
                        <div className='myLabel'> No tiene cuenta? Cree una.</div>
                    </Link>*/}
                    

                    <div className='myLabel error' style={{ visibility: this.props.errorAutenticacion ? 'visible' : 'hidden' }} >{this.props.errorAutenticacion || ''}</div>
                </div>
            </div>
        )
    }
}

LoginForm.propTypes = {
    loginData: PropTypes.object.isRequired,
    instalacion:PropTypes.object.isRequired,
    errores: PropTypes.object.isRequired,
    handleOnDataChange: PropTypes.func.isRequired,
    handleOnContraseniaKeyPress: PropTypes.func.isRequired,
    handleOnAutenticar: PropTypes.func.isRequired,
    handleOnOlvidoContrasenia: PropTypes.func.isRequired,
    errorAutenticacion: PropTypes.string
}

export default LoginForm